import cx from 'classnames';
import i18next from 'i18next';
import debounce from 'lodash.debounce';

import { toggleConfirmationPopup } from 'actions/placeorder';
import { updateUserPreference } from 'actions/user';
import submitOrder from 'components/placeorder_v2/ConfirmationModals/orderSubmit.thunk';
import { PLACE_ORDER_TYPE } from 'constants/enums';
import {
  dontShowConfirmationCheckboxCheckedSelector,
  dontShowConfirmationOnChartCheckedSelector,
  orderTypeSelection,
} from 'selectors/placeOrderSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import styles from './Modals.module.scss';

const placeOrderLabel = i18next.t('trading:placeOrder');
const cancelLabel = i18next.t('trading:cancel');

const preferenceTypeMapping = {
  [PLACE_ORDER_TYPE.MARKET]: 'marketOrder',
  [PLACE_ORDER_TYPE.LIMIT]: 'limitOrder',
};

const ConfirmButtons = () => {
  const dispatch = useAppDispatch();
  const preferenceType = useAppSelector(orderTypeSelection);
  const dontShowConfirmation = useAppSelector(
    dontShowConfirmationCheckboxCheckedSelector
  );
  const dontShowConfirmationOnChart = useAppSelector(
    dontShowConfirmationOnChartCheckedSelector
  );

  const handleConfirmationModalClose = () => {
    dispatch(toggleConfirmationPopup(false));
  };

  const handlePlaceOrder = debounce(() => {
    if (dontShowConfirmation) {
      dispatch(
        updateUserPreference(
          {
            preferences: {
              [preferenceTypeMapping[preferenceType]]: !dontShowConfirmation,
            },
          },
          { disable_notification: true }
        )
      );
    }
    if (dontShowConfirmationOnChart) {
      dispatch(
        updateUserPreference(
          {
            preferences: { orderPlacedFromCharts: !dontShowConfirmationOnChart },
          },
          { disable_notification: true }
        )
      );
    }
    dispatch(submitOrder());
    handleConfirmationModalClose();
  }, 400);

  return (
    (<div className={cx('row', styles.confirmRow)} data-palette="ConfirmButtons">
      <div className="col-12">
        <div
          className={styles.placeorderbutton}
          aria-hidden="true"
          data-testid="placeholderButton"
          onClick={handlePlaceOrder}
        >
          {placeOrderLabel}
        </div>
      </div>
      <div className="col-12">
        <div
          className={styles.cancelButton}
          aria-hidden="true"
          data-testid="cancelButton"
          onClick={handleConfirmationModalClose}
        >
          {cancelLabel}
        </div>
      </div>
    </div>)
  );
};

export default ConfirmButtons;
